// extracted by mini-css-extract-plugin
module.exports = {"tosContainer":"TOS_tosContainer__r7U34","tosTitle":"TOS_tosTitle__2HFmx"};